<template lang="pug">
div.detail-layout
  div.row
    div.col-3
      h6 藥物資訊
      hr
      div.form-group
        label 藥碼
        input.form-control(type="text" v-model="medicineData.code")
      div.form-group
        label 料位號
        input.form-control(type="text" v-model="medicineData.CGMH_number")
      div.form-group
        label 學名
        input.form-control(type="text" v-model="medicineData.generic_name")
      div.form-group
        label 產品名
        input.form-control(type="text" v-model="medicineData.product_name")
    div.col-2
      h6 藥盒資訊
      hr
      div.form-group
        label 藥盒條碼
        input.form-control(type="text" v-model="medicineData.package_code2")
      div.form-group
        label 藥瓶（身）條碼
        input.form-control(type="text" v-model="medicineData.package_code")
      div.form-group
        label 盒裝數量
        input.form-control(type="text" v-model="medicineData.pack_content" 
          title="調整盒裝數會影響藥盒內藥物數量，請務必重新盤點")
    div.col-2
      h6 其他資訊
      hr
      div.form-group
        label 管制等級
        input.form-control(type="text" v-model="medicineData.restrained_class")
      div.form-group
        label 衛生署字號
        input.form-control(type="text" v-model="medicineData.license_id")
      div.form-group
        label 製造廠商
        input.form-control(type="text" v-model="medicineData.manufacturer")
      div.switch-wrapper
        div.switch
          input(id="switch-return-when-empty" type="checkbox" v-model="medicineData.return_when_empty")
          label.slider(for="switch-return-when-empty" :class="{ 'slider-on': medicineData.return_when_empty }")
        span.switch-title 需退空瓶
      div.switch-wrapper
        div.switch
          input(id="switch-rx-check" type="checkbox" v-model="medicineData.rx_check")
          label.slider(for="switch-rx-check" :class="{ 'slider-on': medicineData.rx_check }")
        span.switch-title 需覆核
    div.col-5
      h6 藥物圖片
      hr
      div.drug-image-setting
        div.drug-image-wrapper
          img.drug-image(v-if="medicineData.drug_picture_1" :src="medicineData.drug_picture_1")
        div.form-group
          label 藥物照片(ㄧ)
          input.form-control-file(type="file" :id="`${rowIndex}-photo1`" @change="onChange")
      div.drug-image-setting
        div.drug-image-wrapper
          img.drug-image(v-if="medicineData.drug_picture_2" :src="medicineData.drug_picture_2")
        div.form-group
          label 藥物照片(二)
          input.form-control-file(type="file" :id="`${rowIndex}-photo2`" @change="onChange")
      div.drug-image-setting
        div.drug-image-wrapper
          img.drug-image(v-if="medicineData.drug_box_picture" :src="medicineData.drug_box_picture")
        div.form-group
          label 藥盒照片
          input.form-control-file(type="file" :id="`${rowIndex}-photo3`" @change="onChange")
  button.btn.btn-primary.mr-2(@click="updateMedicine") 儲存
  button.btn.btn-danger(@click="deleteMedicine") 刪除
</template>

<script>
export default {
  data() {
    return {
      medicineData: {},
      photo1: null,
      photo2: null,
      photo3: null,
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  mounted() {
    this.medicineData = this.rowData;
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  methods: {
    onChange(event) {
      const id = event.target.id;
      console.log(id);
      console.log(id === `${this.rowIndex}-phtot2`);
      switch (id) {
        case `${this.rowIndex}-photo1`:
          this.photo1 = event.target.files[0];
          break;
        case `${this.rowIndex}-photo2`:
          this.photo2 = event.target.files[0];
          break;
        case `${this.rowIndex}-photo3`:
          this.photo3 = event.target.files[0];
          break;
        default:
          console.log(id);
      }
    },
    updateMedicine() {
      const data = new FormData();
      Object.entries(this.medicineData).forEach((entries) => {
        const key = entries[0];
        const value = entries[1];
        if (key !== 'drug_picture_1' &&
            key !== 'drug_picture_2' &&
            key !== 'drug_box_picture' &&
            key !== 'id' &&
            key !== 'group' &&
            value !== null) {
          console.log(entries[0], entries[1]);
          data.append(entries[0], entries[1]);
        }
      });
      if (this.photo1) data.append('drug_picture_1', this.photo1);
      if (this.photo2) data.append('drug_picture_2', this.photo2);
      if (this.photo3) data.append('drug_box_picture', this.photo3);

      // console.log(data);
      this.instance.patch(`/api/medication/${this.rowData.id}/`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        this.$parent.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新完成',
        });
      });
    },
    deleteMedicine() {
      this.instance.delete(`/api/medication/${this.rowData.id}/`)
      .then(() => {
        this.$parent.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新完成',
        });
      });
    },
  },
};
</script>

<style lang="sass">
.drug-image
  width: 100%

.drug-image-setting
  display: flex
  margin-bottom: 1rem
  .drug-image-wrapper
    width: 50%
    margin-right: 1%
  
</style>



// WEBPACK FOOTER //
// DrugSettingsDetail.vue?724700c5